const en_home = {
  // Hero
  "hero.badge": "Advanced Precision Medicine & Specialty Care Platform",
  "hero.heading_1": "We understand before",
  "hero.words": "we decide|we intervene|we treat|we judge",
  "hero.desc": "The Medical Avenue is not a traditional clinic — it's a precision medicine platform that deconstructs each case, reads beyond the surface, and connects present health to future risks.",
  "hero.sub": "90–120 min sessions · DNA & metabolic assessment · International Second Opinion · Personalized plans, not generic protocols",
  "hero.btn_book": "Book an Assessment",
  "hero.btn_services": "Explore Our Services",
  "hero.pillar_1": "Clinical Depth",
  "hero.pillar_2": "Technical Depth",
  "hero.pillar_3": "International Depth",
  "hero.scroll": "Discover More",

  // TrustBar
  "trust.label": "Our Excellence in Numbers",
  "trust.tagline": "Integrated Precision Medicine & Advanced Specialty Care Platform",

  // FeaturedServices
  "services.badge": "Priority Services",
  "services.heading": "Our Highest-Impact Services",
  "services.desc": "Services that combine clear market need, easy value communication, strong differentiation, and high conversion potential",
  "services.view_all": "View All Services",

  // WhyUs
  "whyus.badge_identity": "Our Visual Identity",
  "whyus.heading_identity": "Four Symbols, One Philosophy",
  "whyus.desc_identity": "These symbols form a visual language of wellness — where science, vitality, balance, and beauty coexist in perfect harmony",
  "whyus.shape_1_label": "Clinical Depth",
  "whyus.shape_1_sub": "More time · Non-rushed assessment",
  "whyus.shape_1_desc": "The star symbolizes medical expertise and guidance toward trusted care",
  "whyus.shape_2_label": "Technical Depth",
  "whyus.shape_2_sub": "DNA · Biological age · Metabolic",
  "whyus.shape_2_desc": "The sun symbolizes vitality, energy, and continuous health activity",
  "whyus.shape_3_label": "Metabolic Balance",
  "whyus.shape_3_sub": "Obesity · MASLD · Metabolic dysfunction",
  "whyus.shape_3_desc": "The swan symbolizes balance and elegant healthy weight management",
  "whyus.shape_4_label": "International Depth",
  "whyus.shape_4_sub": "Second Opinion · USA · Korea",
  "whyus.shape_4_desc": "The lotus symbolizes renewal, inner health, and body-mind harmony",
  "whyus.badge": "Why The Medical Avenue?",
  "whyus.heading": "Deeper Medicine, More Personalized, Precision-Driven",
  "whyus.desc_1": "We are not a faster clinic — we are a deeper one. We deconstruct each case, read beyond the surface, and connect present health to future risks.",
  "whyus.desc_2": "Every patient has a unique biology and health trajectory. That's why we design each plan based on actual assessment, not generic protocols.",
  "whyus.three_dims": "Three Integrated Dimensions",
  "whyus.dim_1": "Clinical Depth",
  "whyus.dim_1_sub": "More time · Non-rushed assessment",
  "whyus.dim_2": "Technical Depth",
  "whyus.dim_2_sub": "DNA · Biological age · Metabolic",
  "whyus.dim_3": "International Depth",
  "whyus.dim_3_sub": "Second Opinion · USA · Korea",
  "whyus.intl": "International Reach",
  "whyus.intl_sub": "USA · Korea · and more",
  "whyus.session": "min per session",
  "whyus.session_sub": "We give each case the time it deserves",

  // TeamPreview
  "team.badge": "Our Medical Team",
  "team.heading": "Elite Specialized Consultants",
  "team.desc": "Every consultant at The Medical Avenue combines deep clinical expertise with specialized international training",
  "team.view_all": "View All Consultants",
  "team.book": "Book Consultation",

  // FeaturedPackages
  "packages.badge": "Care Levels",
  "packages.heading": "Choose the Right Assessment Level",
  "packages.desc": "From comprehensive deep assessment to integrated international care — each level is designed for a different case",
  "packages.view_all": "View All Packages",
  "packages.book": "Book Now",

  // Testimonials
  "testimonials.badge": "Patient Reviews",
  "testimonials.heading": "What Those Who Experienced It Say",
  "testimonials.desc": "Real experiences from patients who chose precision medicine as their path to understanding their health",

  // CTA
  "cta.heading": "Ready for a Real Health Assessment?",
  "cta.desc": "Start your journey with The Medical Avenue — a deep assessment session that builds a clear picture of your health trajectory",
  "cta.btn_book": "Book an Assessment Session",
  "cta.btn_contact": "Contact Us",

  // DNA Simulator Banner
  "dna_banner.badge": "Free Interactive Tool",
  "dna_banner.heading": "Discover Your Health Risk Level",
  "dna_banner.subheading": "DNA Risk Score Simulator",
  "dna_banner.desc": "10 interactive questions analyzing your genetic and environmental risk factors — recommending the most suitable package for your health journey",
  "dna_banner.btn_start": "Start Assessment — Free",
  "dna_banner.btn_service": "Learn About the Real Service",
  "dna_banner.free": "Free",
  "dna_banner.questions": "10 questions · Instant results",
};

export default en_home;
